<template>
  <div v-if="interactions.length > 0">
    <h3 class="ui header">Outline</h3>
    <div class="ui vertically fitted basic padded segment">
      <div class="ui blue link items">
        <div
          class="item"
          :class="{ active: interaction.start === activeItemStart }"
          v-for="interaction in interactions"
          :key="interaction.start"
          @click="goToInteraction(interaction.start)"
        >
          <div class="content">
            <span class="position">{{ interaction.position ? `${interaction.position}.` : '' }}</span>
            <div class="title">{{ interaction.title }}</div>
            <template v-if="interaction.icon">
              <i :class="`teal ${interaction.icon} icon`" />
            </template>
          </div>
        </div>
      </div>
    </div>
    <InteractionModal ref="interactionModal" v-bind="selectedInteraction" />
  </div>
</template>

<script>
import InteractionModal from '@/components/interactions/Modal';
import { mapGetters } from 'vuex';

export default {
  name: 'Outline',
  props: ['syncguid', 'standard'],
  components: {
    InteractionModal,
  },
  data() {
    return {
      selectedInteraction: {
        title: '',
        data: null,
      },
    };
  },
  computed: {
    ...mapGetters({ currentTime: 'video/currentTime' }),
    interactions() {
      const intArray =
        this.$store.getters.contentById(this.syncguid).interactions || [];
      return intArray.sort((a, b) => (a.start > b.start ? 1 : -1));
    },
    activeItemStart() {
      if (this.currentTime === 0) {
        return false;
      }
      let start = 0;
      this.interactions.forEach(i => {
        if (i.start <= this.currentTime && i.start > start) {
          start = i.start;
        }
      });
      return start;
    },
    triggerInteraction() {
      if (this.currentTime === 0) {
        return false;
      }
      return this.interactions.find(
        i => Math.floor(this.currentTime) === i.start,
      );
    },
  },
  methods: {
    goToInteraction(start) {
      this.$store.commit('video/addEvent', { id: 'seek', value: start });
    },
  },
  watch: {
    triggerInteraction(val, old) {
      if (val && (!old || (val && val.start !== old.start))) {
        this.$store.commit('video/setItem', { key: 'tip', value: null });
        this.selectedInteraction = {
          ...val,
          standard: this.standard,
        };
        if (this.selectedInteraction.type === 'ticker') {
          this.$store.commit('video/setItem', { key: 'tip', value: val });
        } else if (this.selectedInteraction.type !== 'section_title') {
          this.$refs.interactionModal.showModal();
        }
      }
    },
  },
};
</script>

<style lang="less" scoped>
.item {
  &.active {
    background-color: #dcf1d4;
  }
  .content {
    display: flex !important;
    .position {
      display: inline-block;
      width: 1.5em;
      padding-right: 0.5em;
      text-align: right;
    }
    .title {
      flex: 90%;
      padding-right: 5px;
    }
    .icon {
      align-self: flex-end;
      margin: auto 0;
    }
  }
}
</style>
